import FormComp from '../FormComp';
import styles from './SquareTransfer.module.css';

import { useEffect, useState } from 'react';
import { formatCPF } from '../../Funcoes/FormatCPF';
import { IoCloseSharp } from 'react-icons/io5';

import useApi from '../../hooks/useApi';
import { useModal } from '../../contexts/ModalContext';
import Overlay from '../Overlay';
import Modal from '../Utils/Modal';
import SmallLoading from '../Utils/SmallLoading';

const formatarDataBr = (value) => {
    if (!value) return '';
    const onlyDate = String(value).split(' ')[0];
    const parts = onlyDate.split('-');
    if (parts.length !== 3) return String(value);
    const [year, month, day] = parts;
    if (!year || !month || !day) return String(value);
    return `${day}/${month}/${year}`;
};

const getSolicitanteNome = (solicitante, lideres = []) => {
    if (!solicitante) return '';
    const match = (lideres || []).find((l) => String(l.value) === String(solicitante));
    return match?.label || String(solicitante);
};

/* Modal de visualização de uma transferência existente. Após a refatoração
   para suportar transferência em massa, este componente deixou de ser usado
   na criação — para criar transferências usamos o SquareNewTransfer.
   Aqui só carregamos um registro pelo id e exibimos em modo somente leitura
   (mesma "cara" de formulário, todos os inputs disabled e sem botão de
   salvar). */

const SquareTransfer = ({ obras, lideres, onClose, editingId }) => {

    const api = useApi();
    const { closeModal } = useModal();

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            closeModal();
        }
    };

    const [formValues, setFormValues] = useState({
        matricula: '',
        nome: '',
        cpf: '',
        funcao: '',
        ccOrigem: '',
        ccDestino: '',
        prevCheg: '',
        solicitante: ''
    });

    const [loadingData, setLoadingData] = useState(false);

    /* Carrega o registro existente quando o modal abre. */
    useEffect(() => {

        if (!editingId) return;

        const fetchProcesso = async () => {

            setLoadingData(true);

            try {

                const { data } = await api.post('/Painel/API/GetProcessoInfo/', {
                    id: editingId,
                    motivo: 'TRANSFERENCIA'
                });

                setFormValues({
                    matricula: data.matricula ?? '',
                    nome: data.nome ?? '',
                    cpf: data.cpf ?? '',
                    funcao: data.funcao ?? '',
                    ccOrigem: data.cc_origem ?? '',
                    ccDestino: data.cc_destino ?? '',
                    prevCheg: data.prev_chegada ?? '',
                    solicitante: data.solicitante ?? '',
                    id: data.id
                });

            } catch (error) {

                console.log(error);

            } finally {

                setLoadingData(false);

            }

        };

        fetchProcesso();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editingId]);

    return (
        <Overlay state={true}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <div className={styles.closeBtn} onClick={handleClose}>
                        <IoCloseSharp />
                    </div>
                </div>
                <div className={styles.formContainer}>

                    <form onSubmit={(e) => e.preventDefault()}>
                        <FormComp
                            title="MATRICULA"
                            type="text"
                            valor={formValues.matricula}
                            readOnly
                        />
                        <FormComp
                            title="NOME"
                            type="text"
                            readOnly
                            valor={formValues.nome}
                        />
                        <FormComp
                            title="CPF"
                            type="text"
                            readOnly
                            valor={formatCPF(formValues.cpf)}
                        />
                        <FormComp
                            title="FUNÇÃO"
                            type="text"
                            readOnly
                            valor={formValues.funcao}
                        />
                        <FormComp
                            title="CC ORIGEM"
                            type="text"
                            valor={formValues.ccOrigem}
                            readOnly
                        />
                        <FormComp
                            title="CC DESTINO"
                            type="text"
                            valor={formValues.ccDestino}
                            readOnly
                        />
                        <FormComp
                            title="SOLICITANTE"
                            type="text"
                            valor={getSolicitanteNome(formValues.solicitante, lideres)}
                            readOnly
                        />
                        <FormComp
                            title="PREV. CHEGADA"
                            type="text"
                            valor={formatarDataBr(formValues.prevCheg)}
                            readOnly
                        />
                    </form>

                </div>
                {loadingData && (
                    <Overlay state={true}>
                        <Modal size="sm">
                            <SmallLoading />
                        </Modal>
                    </Overlay>
                )}
            </div>
        </Overlay>
    );

};

export default SquareTransfer;